export default function faq() {
  $('.block.faq').each(function () {
    const $block = $(this);

    /**
     * Clicking on faq header
     */
    $block.find('.faq__header').click(function () {
      const $section = $(this).closest('.faq__section');

      if ($section.hasClass('active')) {
        //Close this one
        $section.removeClass('active');
        $section.find('.faq__questions').slideUp(250, function () {
          //closing questions inside this section
          $section.find('.faq__question__title.active').click();
        });
      } else {
        //Open this one
        $section.addClass('active');
        $section.find('.faq__questions').slideDown();
      }
    });

    /**
     * Clicking on faq question
     */
    $block.find('.faq__question__title').click(function (e) {
      const $questions = $(this).closest('.faq__questions');
      const $question = $(this);

      if ($question.hasClass('active')) {
        //Close this one
        $question.removeClass('active');
        $question.next('.faq__answer').slideUp(250);
      } else {
        //Open this one
        $question.addClass('active');
        $question.next('.faq__answer').slideDown(250);
      }
    });
  });
}
